
import { Vue, Options } from "vue-class-component";
import { Prop, Watch, Ref } from "vue-property-decorator";
import Store from "../../store";
import ActionButton from "../atoms/ActionButton.vue";
import HelpIcon from "../atoms/HelpIcon.vue";
import { InstructionLevel } from "../../types";
import UIkit from "uikit";
import sanitizeHTML from "sanitize-html";
const storeInstance = Store.getInstance();

@Options({
  components: { ActionButton, HelpIcon }
})
export default class Page extends Vue {
  @Prop({ type: String }) title = "";
  @Prop({ type: Boolean }) backable = false;
  @Ref("instructionModal") instructionModal!: HTMLElement;
  @Prop({ type: String }) loadingMessage?: string = "";
  @Ref("loadingModal") loadingModal!: HTMLElement;
  @Prop({ type: String }) helpInfoTitle = "";
  @Prop({ type: String }) departmentPath = "";
  @Prop({ type: String }) statusName = "";
  instruction: {
    level: InstructionLevel;
    message: string;
    callback?: Function;
  } = storeInstance.getInstruction();
  isLoading: { state: boolean; message: string } = storeInstance.getIsLoading();
  confirmation = false;
  currentTimeout!: ReturnType<typeof setTimeout>;
  clearInstruction() {
    Store.getInstance().setInstructionContent(InstructionLevel.None, "");
  }
  onAlertCloseButtonClick() {
    this.clearInstruction();
  }
  sanitize(html: string) {
    return sanitizeHTML(html);
  }
  @Watch("instruction.level")
  onInstructionMessageChange(newValue: string) {
    if (newValue === "info") {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = setTimeout(() => {
        if (this.instruction.level === InstructionLevel.Info) {
          // @ts-ignore
          UIkit.util.once(this.$refs.instructionAlert as HTMLElement, "hide", () => {
            this.clearInstruction();
          });
          UIkit.alert(this.$refs.instructionAlert as HTMLElement).close();
        }
      }, 5000);
    } else if ([InstructionLevel.Confirm, InstructionLevel.Alert].includes(newValue as InstructionLevel)) {
      this.$nextTick(() => {
        UIkit.modal(this.instructionModal).show();
        // @ts-ignore
        UIkit.util.once(this.instructionModal, "hide", () => {
          if (this.confirmation) {
            if (this.instruction.callback) {
              this.instruction.callback.call(this);
            }
            this.clearInstruction();
            this.confirmation = false;
          }
        });
      });
    }
  }
  @Watch("isLoading.state")
  changeLoadingStatus(flg: boolean) {
    if (flg) {
      this.loadingMessage = this.isLoading.message;
      UIkit.modal(this.loadingModal).show();
    } else {
      UIkit.modal(this.loadingModal).hide();
    }
  }
  onConfirmed() {
    this.confirmation = true;
    UIkit.modal(this.instructionModal).hide();
    this.$emit("confirmed");
  }
  beforeUnmount() {
    if (this.instruction.level === InstructionLevel.Info) {
      // @ts-ignore
      UIkit.util.once(this.$refs.instructionAlert as HTMLElement, "hide", () => {
        this.clearInstruction();
      });
      UIkit.alert(this.$refs.instructionAlert as HTMLElement).close();
    }
  }
}
